import { render, staticRenderFns } from "./Consentform.vue?vue&type=template&id=69949d9d&scoped=true&"
import script from "./Consentform.vue?vue&type=script&lang=js&"
export * from "./Consentform.vue?vue&type=script&lang=js&"
import style0 from "./Consentform.vue?vue&type=style&index=0&id=69949d9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69949d9d",
  null
  
)

export default component.exports